import { render, staticRenderFns } from "./OidcOauth.vue?vue&type=template&id=a8538b78&"
import script from "./OidcOauth.vue?vue&type=script&lang=js&"
export * from "./OidcOauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports